import {Injectable, Signal, signal, WritableSignal} from '@angular/core';
import {catchError, EMPTY, Observable, take, tap} from "rxjs";
import {ApiStandardReturn} from "../../models/api-standard-return";
import {SystemParams} from "../../models/system-params";
import {BaseApiService} from "../base-api-service/base-api.service";
import {HttpErrorResponse} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class SystemParamsService extends BaseApiService {
  private readonly resource ="/system-parameters";

  private logo: WritableSignal<string>  = signal('');
  private name: WritableSignal<string> = signal('Department');
  private error: WritableSignal<HttpErrorResponse | null> = signal(null);

  getLogo(): Signal<string> {
    return this.logo.asReadonly();
  }

  getName(): Signal<string> {
    return this.name.asReadonly();
  }

  getError(): Signal<HttpErrorResponse | null> {
    return this.error.asReadonly();
  }

  loadSystemParams(): Observable<ApiStandardReturn<SystemParams>> {
    return this.http.get<ApiStandardReturn<SystemParams>>(this.apiUrl + this.resource).pipe(
      take(1),
      tap(response => {
        if(response.data.lightLogo){
          this.logo.set("data:image/png;base64," + response.data.lightLogo);
        }
        this.name.set(response.data.name);
        this.error.set(null);
      }),
      catchError((error: HttpErrorResponse)=>{
        this.error.set(error);
        return EMPTY;
      }),
    );
  }
}
